import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s:mb-16 text-sm l:text-base" }
const _hoisted_2 = { class: "bg-merinos-50 rounded-[36px] m:rounded-4xl p-2 w-full flex items-center justify-between relative gap-x-4 m:gap-x-0" }
const _hoisted_3 = {
  key: 0,
  class: "m:flex items-center m:space-x-6"
}
const _hoisted_4 = { class: "hidden m:block w-full" }
const _hoisted_5 = { class: "rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-[260px] m:w-[200px] l:w-[300px] cursor-pointer" }
const _hoisted_6 = { class: "whitespace-nowrap overflow-hidden" }
const _hoisted_7 = { class: "hidden m:block" }
const _hoisted_8 = { class: "flex items-center gap-x-2" }
const _hoisted_9 = { class: "hidden m:block" }
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = { class: "whitespace-nowrap overflow-hidden" }
const _hoisted_12 = { class: "hidden m:block" }
const _hoisted_13 = { class: "flex justify-end mb-6" }
const _hoisted_14 = { class: "flex flex-col gap-y-4" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center gap-x-6"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex justify-between gap-x-6" }
const _hoisted_18 = { class: "px-6 py-4 rounded-t-3xl border border-merinos-100 shadow-card" }

import { computed, onMounted, ref, toRaw, watch, nextTick } from "vue";
import { format } from 'date-fns'
import { useBreakpoints, useScrollLock } from '@vueuse/core'
import Destination from './Destination.vue';
import Travelers from "./Travelers.vue";
import Dropdown from './Dropdown.vue';
import { objectToURLSearchParams } from "@studiometa/js-toolkit/utils";
import Alert from "../../molecules/Alert.vue";


export default {
  __name: 'Search',
  props: {
  france: {
    type: Array,
    default: () => ([]),
  },
  nearTo: {
    type: Array,
    default: () => ([]),
  },
  envie: {
    type: Array,
    default: () => ([]),
  },
  trad: {
    type: Object,
    required: true,
  },
  action: {
    type: String,
    required: true,
  },
  defaultTermId: {
    type: Number,
    required: false,
  },
  datepickerContent: {
    type: String,
    required: false,
  },
  datepickerType: {
    type: String,
    required: false,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const currentLocale = window.navigator.language;

const searchParams = new URLSearchParams(
 decodeURIComponent(window.location.search)
);

const defaultDate = [
  searchParams.get('from') ? new Date(searchParams.get('from')) : false,
  searchParams.get('to') ? new Date(searchParams.get('to')) : false,
].filter(Boolean);

const defaultFrance = [];
const defaultNearTo = [];
const defaultEnvie = [];

for (const key of searchParams.keys()) {
  if (key.includes('france')) {
    defaultFrance.push(Number(searchParams.get(key)));
  }

  if (key.includes('proche-de')) {
    defaultNearTo.push(Number(searchParams.get(key)));
  }

  if (key.includes('envie')) {
    defaultEnvie.push(Number(searchParams.get(key)))
  }
}

const franceTaxonomy = ref(props.france);
const nearToTaxonomy = ref(props.nearTo);
const envieTaxonomy = ref(props.envie);

/**
 * Form state
 */
const date = ref(defaultDate); // from-to
const destination = ref([]); // ids for 'france'|'proche-de'|'envie' taxonomies
const destinationType = ref(props.trad.search_taxonomies_enabled[0].value ?? 'france');
const TRAVELERS = ref([
  {
    label: props.trad.remote_adults,
    description: props.trad.remote_adults_legend,
    name: 'adult',
    value: Number(searchParams.get('adult')) ?? 0,
  },
  {
    label: props.trad.remote_kids,
    description: props.trad.remote_kids_legend,
    name: 'child',
    value: Number(searchParams.get('child')) ?? 0,
  },
  {
    label: props.trad.remote_babies,
    description: props.trad.remote_babies_legend,
    name: 'babies',
    value: Number(searchParams.get('babies')) ?? 0,
  },
  {
    label: props.trad.remote_dogs,
    description: props.trad.remote_dogs_legend,
    name: 'dog',
    value: Number(searchParams.get('dog')) ?? 0,
  },
]);

if (defaultEnvie.length > 0) {
  if (props.trad.search_taxonomies_enabled.some((taxonomy) => taxonomy.value === 'envie')) {
    destinationType.value = 'envie';
    destination.value = defaultEnvie;
  }
} else if (defaultNearTo.length > 0) {
  if (props.trad.search_taxonomies_enabled.some((taxonomy) => taxonomy.value === 'proche-de')) {
    destinationType.value = 'proche-de';
    destination.value =  defaultNearTo;
  }
} else {
  if (props.trad.search_taxonomies_enabled.some((taxonomy) => taxonomy.value === 'france')) {
    destinationType.value = 'france';
    destination.value =  defaultFrance;
  }
}

const isOpened = ref(false); // panel
nextTick(() => {
  isOpened.value = props.isOpen;
});

const dropdownActiveIndex = ref(0); // mobile dropdowns
const breakpoints = useBreakpoints({
  m: 1024,
  l: 1280
});
const errors = ref([]);
const isMobile = breakpoints.smaller('m');

const intl = new Intl.DateTimeFormat();
const TODAY = new Date();

const isLocked = useScrollLock(document.body);

watch(isOpened, (shouldLock) => {
  isLocked.value = shouldLock;
})


onMounted(() => {
  if (date.value.length === 0) {
    let startDate = new Date();
    startDate.setDate(startDate.getDate() + 2);
    const endDate = new Date(new Date().setDate(startDate.getDate() + 2));
    date.value = [startDate, endDate];
  }

  if (props.defaultTermId) {
    const isEnvie = props.envie.find((row) => row?.id === props.defaultTermId);
    if (isEnvie) {
      destinationType.value = 'envie';
    }

    destination.value.push(props.defaultTermId);
  }
})

const totalTravelers = computed(() => TRAVELERS.value.reduce(
  (accumulator, currentValue) => accumulator + currentValue.value,
  0
))

const computedDestinations = computed(() => {
  if (destination.value.includes('ALL')) {
    if (destinationType.value === 'proche-de') {
      return props.trad.remote_all_near_to;
    }
    return props.trad.remote_all_regions;
  }

  if (destinationType.value === 'france') {
    return franceTaxonomy.value.filter((row) => destination.value.includes(row.id)).map((row) => row.name).join(', ');
  }

  if (destinationType.value === 'proche-de') {
    return nearToTaxonomy.value.filter((row) => destination.value.includes(row.id)).map((row) => row.name).join(', ');
  }

  if (destinationType.value === 'envie') {
    return envieTaxonomy.value.filter((row) => destination.value.includes(row.id)).map((row) => row.name).join(', ');
  }
})

const submitUrl = computed(() => {
  const params = {
    from: format(new Date(date.value?.[0]), 'yyyy-MM-dd'),
    to: format(new Date(date.value?.[1]), 'yyyy-MM-dd'),
    adult: TRAVELERS.value[0].value,
    child: TRAVELERS.value[1].value,
    babies: TRAVELERS.value[2].value,
    dog: TRAVELERS.value[3].value,
  }

  if (destination.value.length > 0 && !destination.value.includes('ALL')) {
    params[destinationType.value] = toRaw(destination.value);
  }

  const qs = objectToURLSearchParams(params, '');

  return `${props.action}?${qs.toString()}`;
})

function submit() {
  errors.value = [];

  if (totalTravelers.value === 0) {
    errors.value.push({
      message: props.trad.error_no_traveler,
      type: 'NO_TRAVELER',
    });
  }

  if (date.value.length < 2) {
    errors.value.push({
      message: props.trad.error_no_date,
      type: 'NO_DATE',
    });
  }

  if (errors.value.length > 0) {
    return;
  }

  window.location.href = submitUrl.value;
}

return (_ctx, _cache) => {
  const _component_VDropdown = _resolveComponent("VDropdown")
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")
  const _component_VueSidePanel = _resolveComponent("VueSidePanel")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Desktop fields "),
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_VDropdown, null, {
              popper: _withCtx(() => [
                _createVNode(Destination, {
                  modelValue: destination.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((destination).value = $event)),
                  france: franceTaxonomy.value,
                  nearTo: nearToTaxonomy.value,
                  envie: envieTaxonomy.value,
                  trad: __props.trad,
                  "destination-type": destinationType.value,
                  onChangeType: _cache[1] || (_cache[1] = (value) => destinationType.value = value)
                }, null, 8 /* PROPS */, ["modelValue", "france", "nearTo", "envie", "trad", "destination-type"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(computedDestinations.value?.length > 0 ? computedDestinations.value : __props.trad.remote_switch), 1 /* TEXT */),
                    _cache[14] || (_cache[14] = _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "#C3B6A6"
                      }),
                      _createElementVNode("path", {
                        d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                        fill: "#594631"
                      })
                    ], -1 /* HOISTED */))
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_VDropdown, null, {
              popper: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(Alert, {
                    message: __props.datepickerContent,
                    type: __props.datepickerType
                  }, null, 8 /* PROPS */, ["message", "type"]),
                  _createVNode(_component_VueDatePicker, {
                    modelValue: date.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((date).value = $event)),
                    "min-date": _unref(TODAY),
                    locale: _unref(currentLocale),
                    inline: "",
                    range: "",
                    "auto-apply": "",
                    "multi-calendars": "",
                    "month-change-on-scroll": false,
                    "enable-time-picker": false,
                    "prevent-min-max-navigation": "",
                    required: ""
                  }, {
                    "action-preview": _withCtx(() => _cache[18] || (_cache[18] = [])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "min-date", "locale"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-[320px] cursor-pointer transition-all ease", {
                'outline outline-terra-900': errors.value.find((error) => error.type === 'NO_DATE')
              }])
                  }, [
                    _cache[16] || (_cache[16] = _createElementVNode("svg", {
                      class: "mr-4",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("mask", {
                        id: "mask0_1666_6707",
                        style: {"mask-type":"alpha"},
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "24",
                        height: "24"
                      }, [
                        _createElementVNode("rect", {
                          width: "24",
                          height: "24",
                          fill: "#D9D9D9"
                        })
                      ]),
                      _createElementVNode("g", { mask: "url(#mask0_1666_6707)" }, [
                        _createElementVNode("path", {
                          d: "M3.5 21.5V4.50002H6.69233V2.38464H8.23075V4.50002H15.8077V2.38464H17.3076V4.50002H20.5V21.5H3.5ZM4.99997 20H19V10.3077H4.99997V20ZM4.99997 8.80774H19V5.99999H4.99997V8.80774Z",
                          fill: "currentColor"
                        })
                      ])
                    ], -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(date.value?.[0] ? _unref(intl).format(date.value[0]) : __props.trad.remote_start), 1 /* TEXT */),
                      _cache[15] || (_cache[15] = _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("mask", {
                          id: "mask0_1666_6711",
                          style: {"mask-type":"alpha"},
                          maskUnits: "userSpaceOnUse",
                          x: "0",
                          y: "0",
                          width: "24",
                          height: "24"
                        }, [
                          _createElementVNode("rect", {
                            width: "24",
                            height: "24",
                            fill: "#D9D9D9"
                          })
                        ]),
                        _createElementVNode("g", { mask: "url(#mask0_1666_6711)" }, [
                          _createElementVNode("path", {
                            d: "M14.0481 17.6538L12.9942 16.5692L16.8135 12.75H4.2981V11.25H16.8135L12.9942 7.43079L14.0481 6.34619L19.7019 12L14.0481 17.6538Z",
                            fill: "#A99982"
                          })
                        ])
                      ], -1 /* HOISTED */)),
                      _createElementVNode("span", null, _toDisplayString(date.value?.[1] ? _unref(intl).format(date.value[1]) : __props.trad.remote_in), 1 /* TEXT */)
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("svg", {
                      class: "ml-4",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "#C3B6A6"
                      }),
                      _createElementVNode("path", {
                        d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                        fill: "#594631"
                      })
                    ], -1 /* HOISTED */))
                  ], 2 /* CLASS */)
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_VDropdown, null, {
              popper: _withCtx(() => [
                _createVNode(Travelers, {
                  travelers: TRAVELERS.value,
                  trad: __props.trad
                }, null, 8 /* PROPS */, ["travelers", "trad"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["rounded-full pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-[200px] cursor-pointer transition-all ease", {
                'outline outline-terra-900': errors.value.find((error) => error.type === 'NO_TRAVELER')
              }])
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[19] || (_cache[19] = _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("mask", {
                          id: "mask0_1666_6755",
                          style: {"mask-type":"alpha"},
                          maskUnits: "userSpaceOnUse",
                          x: "0",
                          y: "0",
                          width: "24",
                          height: "24"
                        }, [
                          _createElementVNode("rect", {
                            width: "24",
                            height: "24",
                            fill: "#D9D9D9"
                          })
                        ]),
                        _createElementVNode("g", { mask: "url(#mask0_1666_6755)" }, [
                          _createElementVNode("path", {
                            d: "M16.9422 14.3077C16.3191 14.3077 15.7884 14.0884 15.3499 13.65C14.9114 13.2115 14.6922 12.6807 14.6922 12.0577C14.6922 11.4346 14.9114 10.9038 15.3499 10.4654C15.7884 10.0269 16.3191 9.80768 16.9422 9.80768C17.5653 9.80768 18.096 10.0269 18.5345 10.4654C18.9729 10.9038 19.1922 11.4346 19.1922 12.0577C19.1922 12.6807 18.9729 13.2115 18.5345 13.65C18.096 14.0884 17.5653 14.3077 16.9422 14.3077ZM12.1922 19.3077V18.1577C12.1922 17.8025 12.283 17.4765 12.4646 17.1795C12.6463 16.8825 12.9042 16.6688 13.2384 16.5385C13.82 16.2949 14.4218 16.1122 15.0438 15.9904C15.6658 15.8686 16.2986 15.8077 16.9422 15.8077C17.5728 15.8077 18.1994 15.8686 18.8219 15.9904C19.4444 16.1122 20.0524 16.2949 20.646 16.5385C20.9802 16.6688 21.2381 16.8825 21.4197 17.1795C21.6014 17.4765 21.6922 17.8025 21.6922 18.1577V19.3077H12.1922ZM9.80757 11.6923C8.84508 11.6923 8.02113 11.3496 7.33572 10.6642C6.65032 9.97876 6.30762 9.15481 6.30762 8.19233C6.30762 7.22983 6.65032 6.40588 7.33572 5.72048C8.02113 5.03506 8.84508 4.69235 9.80757 4.69235C10.7701 4.69235 11.594 5.03506 12.2794 5.72048C12.9648 6.40588 13.3075 7.22983 13.3075 8.19233C13.3075 9.15481 12.9648 9.97876 12.2794 10.6642C11.594 11.3496 10.7701 11.6923 9.80757 11.6923ZM2.30762 19.3077V16.9615C2.30762 16.541 2.44319 16.1375 2.71434 15.751C2.98549 15.3644 3.37427 15.0449 3.88067 14.7923C4.76143 14.3282 5.70569 13.9648 6.71344 13.702C7.72121 13.4391 8.75258 13.3077 9.80757 13.3077C10.2191 13.3077 10.6422 13.3314 11.0768 13.3789C11.5114 13.4263 11.9248 13.4975 12.3171 13.5923V14.5654C12.1479 14.6359 12.0069 14.7038 11.894 14.7691C11.7811 14.8344 11.6625 14.9062 11.5383 14.9846C11.2576 14.9205 10.9691 14.875 10.6729 14.8481C10.3768 14.8211 10.0883 14.8077 9.80757 14.8077C8.87295 14.8077 7.95437 14.9147 7.05182 15.1288C6.14925 15.3429 5.28578 15.6666 4.46142 16.1C4.26912 16.2025 4.11207 16.3368 3.99027 16.5029C3.86847 16.6689 3.80757 16.8628 3.80757 17.0846V17.8077H9.80757V19.3077H2.30762ZM9.80757 10.1923C10.3576 10.1923 10.8284 9.99649 11.2201 9.60483C11.6117 9.21316 11.8076 8.74233 11.8076 8.19233C11.8076 7.64233 11.6117 7.17149 11.2201 6.77983C10.8284 6.38816 10.3576 6.19233 9.80757 6.19233C9.25757 6.19233 8.78674 6.38816 8.39507 6.77983C8.0034 7.17149 7.80757 7.64233 7.80757 8.19233C7.80757 8.74233 8.0034 9.21316 8.39507 9.60483C8.78674 9.99649 9.25757 10.1923 9.80757 10.1923Z",
                            fill: "#A99982"
                          })
                        ])
                      ], -1 /* HOISTED */)),
                      _createElementVNode("span", null, _toDisplayString(totalTravelers.value > 0 ? `${totalTravelers.value} ${__props.trad.remote_travelers}` : __props.trad.remote_who), 1 /* TEXT */)
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "#C3B6A6"
                      }),
                      _createElementVNode("path", {
                        d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
                        fill: "#594631"
                      })
                    ], -1 /* HOISTED */))
                  ], 2 /* CLASS */)), [
                    [_directive_tooltip, {
                content: __props.trad.error_no_traveler,
                shown: errors.value.find((error) => error.type === 'NO_TRAVELER'),
                triggers: [],
                autoHide: false,
                distance: 16,
              }]
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Mobile field to open the panel "),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = $event => (isOpened.value = true)),
        class: "flex-1 rounded-[24px] pl-4 pr-3 py-3 flex justify-between items-center text-merinos-800 font-medium bg-satin w-[260px] m:w-[300px] cursor-pointer m:hidden"
      }, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(computedDestinations.value?.length > 0 ? computedDestinations.value : __props.trad.remote_switch), 1 /* TEXT */),
        _cache[21] || (_cache[21] = _createElementVNode("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("rect", {
            width: "24",
            height: "24",
            rx: "12",
            fill: "#C3B6A6"
          }),
          _createElementVNode("path", {
            d: "M12 16.0312L7 11.0312L8.0625 9.96875L12 13.9062L15.9375 9.96875L17 11.0312L12 16.0312Z",
            fill: "#594631"
          })
        ], -1 /* HOISTED */))
      ]),
      _createElementVNode("button", {
        onClick: _withModifiers(submit, ["prevent"]),
        type: "submit",
        class: "btn btn--terra btn--icon btn--search m:absolute m:right-1 m:top-1/2 m:-translate-y-1/2 w-12 h-12 m:w-auto rounded-full m:px-6"
      }, [
        _cache[22] || (_cache[22] = _createStaticVNode("<span class=\"m:mr-[10px]\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><mask id=\"mask0_1666_6762\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"><rect width=\"24\" height=\"24\" fill=\"#D9D9D9\"></rect></mask><g mask=\"url(#mask0_1666_6762)\"><path d=\"M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z\" fill=\"white\"></path></g></svg></span>", 1)),
        _createElementVNode("span", _hoisted_12, _toDisplayString(__props.trad.remote_search), 1 /* TEXT */)
      ]),
      _createCommentVNode(" Mobile panel "),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_component_VueSidePanel, {
            key: 1,
            modelValue: isOpened.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((isOpened).value = $event)),
            side: "bottom",
            "transition-name": "slide-bottom",
            "hide-close-btn": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = $event => (isOpened.value = false)),
                  class: "text-merinos-800 font-black tracking-wide pb-1 border-b border-[#DBC2B5] hover:text-merinos-500"
                }, _toDisplayString(__props.trad.close), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(Dropdown, {
                  label: __props.trad.remote_where,
                  description: computedDestinations.value?.length > 0 ? computedDestinations.value : __props.trad.remote_all_regions,
                  "is-expanded": dropdownActiveIndex.value === 0,
                  onOpen: _cache[7] || (_cache[7] = $event => (dropdownActiveIndex.value = 0))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(Destination, {
                        modelValue: destination.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((destination).value = $event)),
                        france: franceTaxonomy.value,
                        nearTo: nearToTaxonomy.value,
                        envie: envieTaxonomy.value,
                        trad: __props.trad,
                        "destination-type": destinationType.value,
                        onChangeType: _cache[6] || (_cache[6] = (value) => destinationType.value = value)
                      }, null, 8 /* PROPS */, ["modelValue", "france", "nearTo", "envie", "trad", "destination-type"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "description", "is-expanded"]),
                _createVNode(Dropdown, {
                  class: _normalizeClass({
                'outline outline-terra-900': errors.value.find((error) => error.type === 'NO_DATE')
              }),
                  label: __props.trad.dates,
                  "is-expanded": dropdownActiveIndex.value === 1,
                  onOpen: _cache[11] || (_cache[11] = $event => (dropdownActiveIndex.value = 1))
                }, {
                  description: _withCtx(() => [
                    (date.value?.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString(_unref(format)(date.value[0], 'dd/MM')), 1 /* TEXT */),
                          _cache[23] || (_cache[23] = _createElementVNode("svg", {
                            class: "flex-1",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("g", null, [
                              _createElementVNode("path", {
                                d: "M14.0481 17.6538L12.9942 16.5692L16.8135 12.75H4.2981V11.25H16.8135L12.9942 7.43078L14.0481 6.34618L19.7019 12L14.0481 17.6538Z",
                                fill: "#A99982"
                              })
                            ])
                          ], -1 /* HOISTED */)),
                          _createElementVNode("span", null, _toDisplayString(_unref(format)(date.value[1], 'dd/MM')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(__props.trad.remote_add_dates), 1 /* TEXT */))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(Alert, {
                        message: __props.datepickerContent,
                        type: __props.datepickerType
                      }, null, 8 /* PROPS */, ["message", "type"]),
                      _createVNode(_component_VueDatePicker, {
                        modelValue: date.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((date).value = $event)),
                        "min-date": _unref(TODAY),
                        locale: _unref(currentLocale),
                        inline: "",
                        range: "",
                        "auto-apply": "",
                        "month-change-on-scroll": false,
                        "enable-time-picker": false,
                        "prevent-min-max-navigation": "",
                        required: ""
                      }, {
                        "action-preview": _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              onClick: _cache[8] || (_cache[8] = $event => (date.value = [])),
                              class: "btn--link"
                            }, _toDisplayString(__props.trad.clear), 1 /* TEXT */),
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = $event => (dropdownActiveIndex.value++)),
                              class: "btn btn--terra flex-1"
                            }, _toDisplayString(__props.trad.next), 1 /* TEXT */)
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "min-date", "locale"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class", "label", "is-expanded"]),
                _withDirectives((_openBlock(), _createBlock(Dropdown, {
                  class: _normalizeClass({
                'outline outline-terra-900': errors.value.find((error) => error.type === 'NO_TRAVELER')
              }),
                  label: __props.trad.remote_travelers,
                  description: totalTravelers.value > 0 ? `${totalTravelers.value} ${__props.trad.remote_travelers}` : __props.trad.remote_add_persons,
                  "is-expanded": dropdownActiveIndex.value === 2,
                  onOpen: _cache[12] || (_cache[12] = $event => (dropdownActiveIndex.value = 2))
                }, {
                  default: _withCtx(() => [
                    _createVNode(Travelers, {
                      travelers: TRAVELERS.value,
                      trad: __props.trad
                    }, null, 8 /* PROPS */, ["travelers", "trad"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class", "label", "description", "is-expanded"])), [
                  [_directive_tooltip, {
                content: __props.trad.error_no_traveler,
                shown: errors.value.find((error) => error.type === 'NO_TRAVELER'),
                triggers: [],
                autoHide: false,
                distance: 16,
              }]
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _withModifiers(submit, ["prevent"]),
                  type: "submit",
                  class: "btn btn--terra btn--icon rounded-full w-full"
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("mask", {
                      id: "mask0_1666_6762",
                      style: {"mask-type":"alpha"},
                      maskUnits: "userSpaceOnUse",
                      x: "0",
                      y: "0",
                      width: "24",
                      height: "24"
                    }, [
                      _createElementVNode("rect", {
                        width: "24",
                        height: "24",
                        fill: "#D9D9D9"
                      })
                    ]),
                    _createElementVNode("g", { mask: "url(#mask0_1666_6762)" }, [
                      _createElementVNode("path", {
                        d: "M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z",
                        fill: "white"
                      })
                    ])
                  ], -1 /* HOISTED */)),
                  _createElementVNode("span", null, _toDisplayString(__props.trad.remote_search), 1 /* TEXT */)
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

}